// Where a subprocessor stores or processes data. Admins pick from these or
// type their own; the API keeps up to 10 places of 60 characters each.
export const DATA_LOCATION_SUGGESTIONS = [
  "United States",
  "European Union",
  "United Kingdom",
  "India",
  "Canada",
  "Australia",
  "Singapore",
  "Japan",
  "Germany",
  "Ireland",
  "Global",
];

export const MAX_DATA_LOCATIONS = 10;

// ["United States", "EU"] -> "United States, EU"
export const formatLocations = (locations) => (locations || []).join(", ");
